const PREFIX = "TECHNICIAN_REPORT_";

export const isTechnicianReportError = (error = {}) =>
  String(error.code || "").startsWith(PREFIX);

export const hasTechnicianReportCheckError = (ep = {}) =>
  (ep.technicianReportCheck || {}).status === "error";

export const hasTechnicianCheckDoctorCopy = (ep = {}) => {
  const check = ep.technicianReportCheck || {};
  return Boolean(check.doctorCopyVerifiedAt || (check.doctor &&
    Array.isArray(check.quarantine) && check.quarantine.length));
};

export const assertTechnicianCheckDoctorUnchanged = (current = {}, nextDoctor) => {
  if (hasTechnicianCheckDoctorCopy(current) && current.doctor !== nextDoctor) {
    const error = new Error("The doctor already has this case, including any copy in problems. Restore or recover that copy before reassignment.");
    error.code = "technician-check-doctor-copy";
    throw error;
  }
};

export const isSameTechnicianReportError = (reviewed = {}, current = {}) => {
  const before = reviewed.technicianReportCheck || {};
  const after = current.technicianReportCheck || {};
  if (after.status !== "error" || before.doctor !== after.doctor || reviewed.doctor !== current.doctor ||
      !["Assigned", "Technician Scored", "Assigned to Doctor"].includes(current.status)) return false;
  if (before.checkId || after.checkId) return Boolean(before.checkId && before.checkId === after.checkId);
  const version = (check) => JSON.stringify([
    check.checkedAt || "", check.folders || [],
    (check.quarantine || []).map((entry) => [entry.folder, entry.problemFolder]),
    (check.errors || []).map((error) => [error.code, error.message, error.actual]),
  ]);
  return version(before) === version(after);
};

export const getTechnicianReportCheckErrors = (ep = {}) => {
  const check = ep.technicianReportCheck || {};
  return check.status === "error" && Array.isArray(check.errors) ? check.errors : [];
};

export const buildReportValidationClearProps = (ep, clearEntry, clearAt) => {
  const technicianCheck = hasTechnicianReportCheckError(ep);
  const remaining = technicianCheck && Array.isArray(ep.reportValidationErrors)
    ? ep.reportValidationErrors.filter((error) => error && !isTechnicianReportError(error))
    : [];
  return {
    reportValidationStatus: remaining.length ? "error" : "ok",
    reportValidationErrors: remaining,
    reportValidationWarnings: technicianCheck ? ep.reportValidationWarnings || [] : [],
    reportValidationSummary: remaining.map((error) => error.message || "").join("; "),
    reportValidationSource: "booking_monitor_manual_clear",
    reportValidationUpdatedAt: clearAt,
    ...(!technicianCheck ? {
      reportValidationManualCleared: true,
      reportValidationManualClearedAt: clearAt,
      reportValidationManualClearedBy: clearEntry.createBy,
    } : {
      technicianReportCheck: {
        ...ep.technicianReportCheck,
        status: "skipped",
        released: false,
        skippedAt: clearAt,
        skippedBy: clearEntry.createBy,
        skippedReason: clearEntry.reason || "",
      },
    }),
  };
};

export const buildReportValidationClearUpdates = (props) =>
  Object.fromEntries(Object.entries(props).flatMap(([key, value]) =>
    key === "technicianReportCheck"
      ? ["status", "released", "skippedAt", "skippedBy", "skippedReason"]
        .map((field) => [`extendedProps.technicianReportCheck.${field}`, value[field]])
      : [[`extendedProps.${key}`, value]],
  ));
